module.exports = __webpack_public_path__ + "static/media/NCCT_LOGO.b87f381f.jpg";